import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";
import Logo from "./Logo";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-black/10 bg-[#faf9f6] mt-24"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="mb-6">
              <Logo />
            </div>
            <p className="text-[#52525b] max-w-md leading-relaxed">
              AI-powered web & mobile application development. Ship in a week,
              not in a quarter. Zero bugs. Minimal cost. Market-ready.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="overline mb-5">Navigate</p>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/"
                  className="text-[#52525b] hover:text-[#0a0a0a] transition-colors"
                  data-testid="footer-link-home"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-[#52525b] hover:text-[#0a0a0a] transition-colors"
                  data-testid="footer-link-about"
                >
                  About
                </Link>
              </li>
              <li>
                <Link
                  to="/work"
                  className="text-[#52525b] hover:text-[#0a0a0a] transition-colors"
                  data-testid="footer-link-work"
                >
                  Work
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-[#52525b] hover:text-[#0a0a0a] transition-colors"
                  data-testid="footer-link-contact"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="overline mb-5">Reach out</p>
            <ul className="space-y-4">
              <li>
                <a
                  href="mailto:hello@pixelkare.com"
                  data-testid="footer-email"
                  className="inline-flex items-center gap-3 text-[#0a0a0a] hover:text-[#1f87bc] transition-colors"
                >
                  <Mail className="h-4 w-4" />
                  hello@pixelkare.com
                </a>
              </li>
              <li className="inline-flex items-center gap-3 text-[#52525b]">
                <MapPin className="h-4 w-4" />
                Bhubaneswar, India
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-black/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#71717a]">
            © {new Date().getFullYear()} PixelKare. Built with AI.
          </p>
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#71717a]">
            Zero bugs · 1 week · Market ready
          </p>
        </div>
      </div>
    </footer>
  );
}
